(() => {
 if(window.bfCartExtrasReady)return;window.bfCartExtrasReady=true;
 let busy=false;
 document.addEventListener('click',async event=>{
  const button=event.target.closest('[data-bf-cart-add]');if(!button||busy)return;
  const region=button.closest('.bf-cart-extras'),status=region.querySelector('[role=status]');
  busy=true;region.querySelectorAll('button').forEach(b=>b.disabled=true);status.textContent='Añadiendo a tu carrito…';
  let added=false;
  try {
   const root=window.Shopify?.routes?.root||'/';
   const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.bfCartAdd),quantity:1}],sections:['minicart-form'],sections_url:location.pathname})});
   const data=await response.json();if(!response.ok)throw new Error(data.description||'No se pudo añadir este producto.');added=true;
   const html=new DOMParser().parseFromString(data.sections?.['minicart-form']||'','text/html');
   const form=html.querySelector('#minicart-form');if(!form)throw new Error('Producto añadido. Abre tu carrito para ver el total actualizado.');
   document.querySelector('#minicart-form').innerHTML=form.innerHTML;
   const cart=await fetch(root+'cart.js').then(r=>r.json());
   document.querySelectorAll('.cart-count').forEach(e=>e.textContent=e.classList.contains('cart-count-drawer')?`(${cart.item_count})`:cart.item_count);
   document.querySelector('header-total-price')?.updateTotal(cart);
   document.querySelector('free-ship-progress-bar')?.init(cart.items_subtotal_price);
   document.querySelector('cart-notification')?.cartAction();
   const next=document.querySelector('.bf-cart-extra-status');if(next)next.textContent='Producto añadido a tu pedido.';
   document.querySelector('[data-bf-cart-add]')?.focus({preventScroll:true});
  } catch(error){const target=document.querySelector('.bf-cart-extra-status')||status;target.textContent=added?'Producto añadido. Recarga para ver tu carrito actualizado; no vuelvas a añadirlo.':error.message;}
  finally{busy=false;if(!added)region.querySelectorAll('button').forEach(b=>b.disabled=false);}
 });
})();
